/* import __COLOCATED_TEMPLATE__ from './pill.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { IntegrationState } from 'embercom/objects/standalone/constants';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';

export interface Args {}

export default class Pill extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;

  get integrationState() {
    return this.finStandaloneService.intercomMessengerConfig.integrationState;
  }

  get stampText() {
    switch (this.integrationState) {
      case IntegrationState.TestMode:
        return this.intl.t('standalone.intercom-messenger.deploy.pill.testing');
      case IntegrationState.Enabled:
        return this.intl.t('standalone.intercom-messenger.deploy.pill.live');
      case IntegrationState.Paused:
        return this.intl.t('standalone.intercom-messenger.deploy.pill.paused');
      default:
        return this.intl.t('standalone.intercom-messenger.deploy.pill.not-set-up');
    }
  }

  get stampColor() {
    switch (this.integrationState) {
      case IntegrationState.Enabled:
        return 'green';
      case IntegrationState.Paused:
        return 'yellow';
      default:
        return 'gray';
    }
  }

  get stampIcon() {
    switch (this.integrationState) {
      case IntegrationState.Enabled:
        return 'rounded-check';
      case IntegrationState.TestMode:
        return 'test';
      case IntegrationState.Paused:
        return 'pause';
      default:
        return undefined;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::IntercomMessenger::Deploy::Pill': typeof Pill;
    'standalone/intercom-messenger/deploy/pill': typeof Pill;
  }
}
